import { render, staticRenderFns } from "./NomUsers.vue?vue&type=template&id=1d3aae74&scoped=true&"
import script from "./NomUsers.ts?vue&type=script&lang=ts&"
export * from "./NomUsers.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d3aae74",
  null
  
)

export default component.exports
import {QTable,QBtn,QTooltip,QSpace,QInput,QIcon,QCard,QCardSection,QSeparator,QToggle,QSpinnerGears,QTr,QTd,QDialog,QBar,QCardActions,ClosePopup} from 'quasar'
component.options.components = Object.assign({QTable,QBtn,QTooltip,QSpace,QInput,QIcon,QCard,QCardSection,QSeparator,QToggle,QSpinnerGears,QTr,QTd,QDialog,QBar,QCardActions}, component.options.components || {})
component.options.directives = Object.assign({ClosePopup}, component.options.directives || {})
